<template>
  <ul class="preview-img">
    <li v-for="(img,index) in showImgList"
        :key="index">
      <el-image
          :src="img"
          fit="cover"
          ref="elImage"
          :preview-src-list="previewList">
      </el-image>
      <div class="tips" @click="previewImg(index)">查看大图</div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "preview-img",
    props: {
      imgList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        curImgIndex: 0
      }
    },

    computed: {
      previewList() {
        const previewArr = this.imgList.map(img => this.$fileBaseUrl + '0x0/' + img.filePath);
        if (!this.curImgIndex) return previewArr;
        return previewArr.slice(this.curImgIndex).concat(previewArr.slice(0,this.curImgIndex));
      },
      showImgList() {
        return this.imgList.map(img => this.$fileBaseUrl + '70x0/' + img.filePath)
      }
    },
    methods: {
      previewImg(index) {
        this.curImgIndex = index;
        this.$refs.elImage[0].clickHandler();
      }
    }

  }
</script>

<style scoped lang="scss">
  .preview-img {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 78px;
      height: 105px;
      border-radius: 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-image {
        width: 100%;
      }
      .tips {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .5);
        color: #fff;
        align-items: center;
        justify-content: center;
        display: none;
        cursor: pointer;
      }
      &:hover {
        .tips {
          display: flex;
        }
      }
    }
  }

</style>